import { render, staticRenderFns } from "./UserCampaignList.vue?vue&type=template&id=5f1f3476&scoped=true"
import script from "./UserCampaignList.vue?vue&type=script&lang=js"
export * from "./UserCampaignList.vue?vue&type=script&lang=js"
import style0 from "./UserCampaignList.vue?vue&type=style&index=0&id=5f1f3476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f3476",
  null
  
)

export default component.exports